import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const mainBookingsRoutes = [
  {
    path: 'bookings',
    name: 'admin-bookings',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.bookings],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-bookings" */ '@bookings/pages/booking/booking.vue'),
  },
  {
    path: 'daily',
    name: 'admin-booking-events-daily',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-booking-events" */ '@bookings/pages/booking-event-daily/booking-event-daily.vue'
      ),
  },
  {
    path: 'booking-events',
    name: 'admin-booking-events',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-booking-events" */ '@bookings/pages/booking-event/booking-event.vue'
      ),
  },
  {
    path: 'calendar',
    name: 'admin-calendar',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-calendar" */ '@bookings/pages/booking-event-calendar-page/booking-event-calendar-page.vue'
      ),
  },
  {
    path: 'week-calendar',
    name: 'admin-week-calendar',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-calendar" */ '@bookings/pages/booking-event-week-calendar-page/booking-event-week-calendar-page.vue'
      ),
  },
  {
    path: 'club-resources-calendar',
    name: 'admin-club-resources-calendar',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-calendar" */ '@bookings/pages/booking-event-calendar-page/booking-event-calendar-page.vue'
      ),
  },
];

export const configurationBookingsRoutes = [
  {
    path: 'schedules',
    name: 'admin-schedules',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.schedules],
    },
    component: () =>
      import(/* webpackChunkName: "admin-schedules" */ '@bookings/pages/schedules/schedules.vue'),
  },
  {
    path: 'slot-price-categories',
    name: 'admin-slot-price-categories',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.slot_price_categories],
      module: ModulesHelper.BOOKINGS_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-slot-price-categories" */ '@bookings/pages/slot-price-category-table/slot-price-category-table.vue'
      ),
  },
  // {
  //   path: 'schedule-slot-ranges',
  //   name: 'admin-schedule-slot-ranges',
  //   meta: {
  //     layout: 'bpc-admin',
  //     withSidebar: true,
  //     permissions: [AuthorizationHelper.fixedPermissions.sidebar.schedule_slot_ranges],
  //     module: ModulesHelper.BOOKINGS_MODULE_NAME,
  //   },
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "admin-schedule-slot-ranges" */ '@bookings/pages/schedule-slot-range-table/schedule-slot-range-table.vue'
  //     ),
  // },
];

export const publicBookingsRoutes = [
  {
    // TODO: Deprecated to be removed
    path: 'calendar/:tenant_id',
    name: 'calendar-public',
    meta: { layout: 'bpc-public-calendar', withSidebar: true, publicRoute: true },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "calendar-public" */ '@bookings/pages/booking-event-calendar-public-page/booking-event-calendar-public-page.vue'
      ),
  },
  {
    // TODO: Deprecated to be removed
    path: 'weekly-calendar/:tenant_id',
    name: 'weekly-calendar',
    meta: { layout: 'bpc-public-calendar', withSidebar: true, publicRoute: true },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "weekly-calendar-public" */ '@bookings/pages/booking-event-weekly-calendar-public/booking-event-weekly-calendar-public.vue'
      ),
  },
  {
    path: 'new-booking',
    name: 'public-bookings',
    meta: {
      layout: 'bpc-public',
      withSidebar: true,
      originShowContact: false,
      menuEntry: 'bookings',
      publicRoute: true,
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "contact-profile-bookings" */ '@bookings/pages/public-booking/public-booking.vue'
      ),
  },
];
